export default __webpack_public_path__ + "static/media/leaf-images.6b2d34d6.png";